// Shared by BioEditor (edit mode) and BioView (read mode) so a bio renders
// identically whether or not the page is in edit mode. Mirrors the rules
// customer-app applies to the same markdown on the public profile.
export const BIO_CONTENT_CSS = {
  "& p": { margin: "0.6em 0" },
  "& ul": { paddingLeft: "1.5em", listStyleType: "disc" },
  "& ol": { paddingLeft: "1.5em", listStyleType: "decimal" },
  "& a": { color: "var(--chakra-colors-blue-600)", textDecoration: "underline" },
  "& h1, & h2, & h3, & h4": { fontWeight: 600, margin: "0.6em 0" },
} as const;
